
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class ScrollToTopButton extends Vue {

  @Prop({
    required: false,
    default: "primary",
  })
  color!: string;

  @Prop({
    required: false,
    default: "secondary",
  })
  iconColor!: string;


  show = false;

  created () {
    window.addEventListener('scroll', this.handleScroll);
  }

  unmounted () {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const top = window.pageYOffset || 0
    this.show = top > 100;
  }

  toTop() {
    this.$vuetify.goTo(0)
  }

}
